export const ExperienceConfig: Array<{
  title: string
  place: string
  date: string
  description: string
  tech: Array<string>
}> = [
  {
    title: "Freelance Developer",
    place: "@Merkelappen.no",
    date: "2024 - Present",
    description:
      "Working on improving an e-commerce website by adding new features, updating designs, and expanding functionality. This includes integrating a commercial printer solution, streamlining payment and order handling, and enhancing the overall user experience.",
    tech: ["React", "TypeScript", "tailwind CSS", "Prisma", "Next.js"],
  },
  {
    title: "Backend Development",
    place: "@Gokstadakademiet",
    date: "2024 - Present",
    description:
      "I am currently studying backend development at Gokstadakademiet, focusing on creating robust and efficient server-side applications. My studies include mastering object-oriented programming, algorithms, and database management with MySQL and SQL. I am also gaining experience with Python and C# for backend logic and leveraging Azure for cloud-based solutions.",
    tech: [
      "Object oriented programming",
      "algorithms",
      "Azure",
      "MySQL",
      "SQL",
      "Python",
      "C#",
    ],
  },
  {
    title: "Frontend Development",
    place: "@Gokstadakademiet",
    date: "2021 - 2024",
    description:
      "I studied frontend development at Gokstadakademiet, learning HTML, CSS, JavaScript, and Node.js to build responsive websites and backend functionality. I also gained experience with React and TypeScript for creating dynamic and maintainable applications.",
    tech: ["HTML", "CSS", "JavaScript", "React", "TypeScript"],
  },
]
